<template>
    <div>

        <section class="report-activity-filtering-area mb-2">
            <b-row align-v="center">
                <b-col lg="12">
                    <div class="report-activity-filtering-area__filter-title mb-1">
                        فلتر حسب:
                    </div>
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__filter-by-order-date-container d-flex mt-1"
                >
                    <div
                        class="report-activity-filtering-area__order-date-title mr-1"
                    >
                        تاريخ التسجيل:
                    </div>
                    <ek-date-picker
                        v-model="filter.registerDate"
                        range
                        name="تاريخ الطلب"
                        class="report-activity-filtering-area__order-date-input"
                    />
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__select-filter-by-report-status-container d-flex"
                >
                    <div
                        class="report-activity-filtering-area__city-order-status-title mr-1 flex-1 mt-2"
                    >
                        النشاط التجاري:
                    </div>
                    <ek-input-select
                        clearable
                        v-model="filter.commercialActivityId"
                        :options="commercialActivities"
                        name="النشاط التجاري"
                        placeholder="ادخل النشاط التجاري"
                        class="report-activity-filtering-area__order-status-input"
                    ></ek-input-select>
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__city-filter-by-report-status-container d-flex mt-1"
                >
                    <div
                        class="report-activity-filtering-area__city-order-status-title mr-1 flex-1"
                    >
                        المدينة:
                    </div>
                    <ek-input-select
                        v-model="filter.cityId"
                        clearable
                        class="noLabel report-activity-filtering-area__order-status-input"
                        name="المدينة"
                        placeholder="المدينة"
                        :options="cities"
                        textLabel="langName"
                    />
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__select-filter-by-report-status-container d-flex"
                >
                    <div
                        class="report-activity-filtering-area__order-status-title mr-1"
                    >
                        حالة الحساب:
                    </div>
                    <ek-input-select
                        v-model="filter.accountStatus"
                        :options="accountStatus"
                        clearable
                        name="statusFtiler"
                        class="report-activity-filtering-area__order-status-input"
                    />
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__filter-by-report-status-container d-flex mt-1"
                >
                    <div class="report-activity-filtering-area__order-status-title mr-1">
                        عدد الاشتراكات
                    </div>
                    <ek-input-text
                        v-model="filter.subscriptionsCount"
                        name="عدد الاشتراكات"
                        placeholder="ادخل عدد الاشتراكات"
                        class="report-activity-filtering-area__order-status-input"
                    ></ek-input-text>
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__date-filter-by-order-date-container d-flex"
                >
                    <div
                        class="report-activity-filtering-area__order-date-title mr-1"
                    >
                        تاريخ الاشتراك:
                    </div>
                    <ek-date-picker
                        v-model="filter.subscriptionDate"
                        range
                        name="تاريخ الطلب"
                        class="report-activity-filtering-area__order-date-input"
                    />
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__filter-by-report-status-container d-flex mt-1"
                >
                    <div
                        class="report-activity-filtering-area__order-status-title mr-1"
                    >
                        حالة الاشتراك:
                    </div>
                    <ek-input-select
                        v-model="filter.subscriptionStatusId"
                        :options="reportSubStatuses"
                        clearable
                        name="statusFtiler"
                        class="report-activity-filtering-area__order-status-input"
                    />
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__filter-by-report-status-container d-flex mt-1"
                >
                    <div class="report-activity-filtering-area__order-status-title mr-1">
                        عدد المتابعين:
                    </div>
                    <ek-input-text
                        v-model="filter.followersCount"
                        name="عدد المتابعين"
                        placeholder="ادخل عدد المتابعين"
                        class="report-activity-filtering-area__order-status-input"
                    ></ek-input-text>
                </b-col>

                <b-col
                    lg="3"
                    md="6"
                    xs="6"
                    class="report-activity-filtering-area__filter-by-report-status-container d-flex mt-1"
                >
                    <div class="report-activity-filtering-area__order-status-title mr-1">
                        عدد الزائرين:
                    </div>
                    <ek-input-text
                        v-model="filter.visitorsCount"
                        name="عدد الزائرين"
                        placeholder="ادخل عدد الزائرين"
                        class="report-activity-filtering-area__order-status-input"
                    ></ek-input-text>
                </b-col>
            </b-row>
        </section>
        
        <ek-table
            class="mt-1"
            :items="activityReportsList.filter(filterActivityReports)"
            :columns="cols"
            no_delete
            no_select
            striped
        >
            <template slot="items.dateCreate" slot-scope="{ value }">
                {{ value ? new Date(value).toLocaleString("en-UK").split(",").reverse().join(" ") : "-" }}
            </template>

            <template slot="items.accountStatuses" slot-scope="{ value }">
                <StatusBadge
                    :statusList="accountStatus"
                    :selectedStatusNumber="value"
                ></StatusBadge>
            </template>

            <template slot="items.endSub" slot-scope="{ props }">
                {{
                    (props.row.startSub && props.row.endSub)
                        ? lastSubscriptionDate(props.row.startSub, props.row.endSub)
                        : "-"
                }}
            </template>

            <template slot="items.age" slot-scope="{ value }">
                {{ value ? value : "" }}
            </template>

            <template slot="items.subStatuses" slot-scope="{props}">
                <StatusBadge
                    v-if="props.row.startSub && props.row.endSub"
                    :statusList="reportSubStatuses"
                    :selectedStatusNumber="props.row.subStatuses"
                ></StatusBadge>
                <div v-else>
                    {{ '-' }}
                </div>
            </template>
        </ek-table>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import StatusBadge from "@global/components/StatusBadge";
import { dateManipulatoin } from "@core/mixins/ui/dateManipulatoin";

export default {
    mixins: [dateManipulatoin],
    computed: {
        ...mapGetters(["activityReportsList"]),
        ...mapState({
            accountStatus: (state) => state.users.accountStatus,
            isUserReportUsersTabActive: (state) =>
                state.reports.isUserReportUsersTabActive,
            isActivityReportUsersTabActive: (state) =>
                state.reports.isActivityReportUsersTabActive,
            activeUserTab: (state) =>
                state.reports.activeUserTab,
            reportSubStatuses: (state) =>
                state.reports.reportSubStatuses,
            subStatus: (state) => state.subscriptions.subStatus,
            activities: (state) => state.activities.activities,
            orderStatusList: (state) => state.reports.orderStatusList,
            commercialActivities: (state) => state.activities.commercialActivities,
            cities: ({ locations }) => locations.cities,

        }),
    },
    components: {
        StatusBadge,
    },
    data: () => ({
        filter: {
            registerDate: "",
            commercialActivityId: null,
            cityId: null,
            accountStatus: null,
            subscriptionsCount: "",
            subscriptionDate: "",
            subscriptionStatusId: null,
            followersCount: null,
            visitorsCount: null
        },
        cols: [
            {
                label: "اسم الفعالية",
                field: "accountName",
            },

            {
                label: "النشاط التجاري",
                field: "commercialActivityName",
            },
            {
                label: "اسم المدينة",
                field: "cityName",
            },
            {
                label: "اسم البلد",
                field: "countryName",
            },
            {
                label: "البريد الالكتروني/رقم الموبايل",
                field: "userName",
            },
            {
                label: "تاريخ التسجيل",
                field: "dateCreate",
            },
            {
                label: "حالة الحساب",
                field: "accountStatuses",
            },
            {
                label: "المتابعين",
                field: "followers",
            },
            {
                label: "الزائرين",
                field: "visitors",
            },
            {
                label: "عدد التعليقات",
                field: "comments",
            },
            {
                label: "عدد الإشعارات",
                field: "notifications",
            },
            {
                label: "عدد الوظائف",
                field: "jobs",
            },
            {
                label: "عدد الوظائف التقدم عليها",
                field: "jobSubmiting",
            },
            {
                label: "عدد الاشتراكات",
                field: "sub",
            },
            {
                label: "تاريخ آخر اشتراك",
                field: "endSub",
            },
            {
                label: "حالة الاشتراك",
                field: "subStatuses",
            },
        ],
    }),
    created() {
        this.getCities()
        this.getActivityReports();
    },
    methods: {
        ...mapActions(["getActivityReports", "getCities"]),
        lastSubscriptionDate(startDate, endDate) {

            let sDate = startDate ? `${new Date(
                startDate
            ).toLocaleDateString()}` : ''

            let eDate = endDate ? `${new Date(
                endDate
            ).toLocaleDateString()}` : ''

            let fullDate = ""

            fullDate = sDate +  '-' + eDate;

            return fullDate;
        },
        filterActivityReports(el) {

            let [
                subscriptionStartDate = null,
                subscriptionEndDate = null,
            ] = this.filter.subscriptionDate?.replace("to", "").replace(" ", "").split(" ");

            let [
                registerStartDate = null,
                registerEndDate = null,
            ] = this.filter.registerDate?.replace("to", "").replace(" ", "").split(" ");
            

            return (
                (el.followers == this.filter.followersCount || !this.filter.followersCount) &&
                (el.commercialActivityId == this.filter.commercialActivityId || !this.filter.commercialActivityId) &&
                (el.cityId == this.filter.cityId || !this.filter.cityId) &&
                (el.visitors == this.filter.visitorsCount || !this.filter.visitorsCount) &&
                (el.sub == this.filter.subscriptionsCount || !this.filter.subscriptionsCount) &&
                (el.subStatuses == this.filter.subscriptionStatusId || !this.filter.subscriptionStatusId) &&
                (el.accountStatuses == this.filter.accountStatus || !this.filter.accountStatus) &&
                ((
                (this.setDateTime(new Date(subscriptionStartDate)) >=
                this.setDateTime(new Date(el.startSub)) &&
                this.setDateTime(new Date(subscriptionStartDate)) <=
                this.setDateTime(new Date(el.endSub)) ) ||
                (this.setDateTime(new Date(subscriptionEndDate)) >=
                this.setDateTime(new Date(el.startSub)) &&
                this.setDateTime(new Date(subscriptionEndDate)) <=
                this.setDateTime(new Date(el.endSub)))
                    ) ||
                this.filter.subscriptionDate.length == 0) &&
                ((this.setDateTime(new Date(el.dateCreate)) >=
                this.setDateTime(new Date(registerStartDate)) &&
                this.setDateTime(new Date(el.dateCreate)) <=
                    this.setDateTime(new Date(registerEndDate))) ||
                this.filter.registerDate.length == 0)
            );
        }
    },
};
</script>

<style lang="scss" scoped>
.report-activity-filtering-area {
  align-items: center;

  @media only screen and (max-width: 780px) {
    flex-direction: column;
  }

  &__order-status-title {
        margin-top: 1.4rem;

        font-size: 1.2rem;

        color: #6e6b7b;

        @media only screen and (max-width: 780px) {
            margin-left: 0px;
        }
    }

  &__city-order-status-title {
        margin-top: 0.4rem;

        font-size: 1.2rem;

        color: #6e6b7b;

        @media only screen and (max-width: 780px) {
            margin-left: 0px;
        }
    }

  &__today-reports-title {
    font-size: 1.5rem;
  }

  &__filter-title {
    font-weight: bold;
    font-size: 1.2rem;

    color: #6e6b7b;
  }

  &__filter-container {
    display: flex;
    gap: 2rem;
  }

  &__filter-by-activity-container {
    display: flex;
  }

  &__activity-filter-title {
    margin-top: 1.4rem;
    font-size: 1.2rem;

    color: #6e6b7b;
  }

  &__activity-filter-input {
    flex: 1;
  }

  &__filter-by-reports-status-container {
    display: flex;
  }

  &__filter-by-order-date-container {
    margin-top: 0.6rem;
  }

  &__date-filter-by-order-date-container {
    margin-top: 2.2rem;
  }

  &__filter-by-report-status-container {
    margin-top: -0.5rem;
  }

  &__city-filter-by-report-status-container {
    margin-top: 0.3rem;
  }

  &__select-filter-by-report-status-container {
    margin-top: 0.3rem;
  }

  &__order-date-title {
    margin-top: 0.6rem;

    font-size: 1.2rem;

    color: #6e6b7b;

    @media only screen and (max-width: 780px) {
      margin-left: 0px;
    }
  }

  &__order-date-input {
    margin-top: -0.9rem;
    flex: 1;
  }

  &__order-status-type {
    margin-top: 1.3rem;

    font-size: 1.2rem;

    color: #6e6b7b;

    @media only screen and (max-width: 780px) {
      margin-left: 0px;
    }
  }

  &__order-status-input {
    flex: 1;
  }
}
</style>
